import { useAppSelector } from '../app/hook';
import { selectPermissions } from '../features/dashboard.slice';

const usePermission = (): Permissions => {
  const permissions = useAppSelector(selectPermissions);
  return permissions;
};

export default usePermission;

interface Permissions {
  menu: Menu;
  widgetPage: WidgetPage;
  extensionPage: ExtensionPage;
  billingPage: BillingPage;
  settingsPage: SettingsPage;
  homePage: HomePage;
}

interface Menu {
  home: boolean;
  widgets: boolean;
  billing: boolean;
  profile: boolean;
  extension: Extension;
  settings: boolean;
  support: boolean;
  downloadYourBot: DownloadYourBot;
  marketplace: boolean;
}

interface Extension {
  self: boolean;
  upgrade: boolean;
}

interface DownloadYourBot {
  self: boolean;
  widget: Widget;
  extension: Extension2;
}

interface Widget {
  self: boolean;
  active: boolean;
  upgrade: boolean;
}

interface Extension2 {
  upgrade: boolean;
  active: boolean;
  self: boolean;
}

interface WidgetPage {
  addNewBot: boolean;
  main: string[];
}

interface ExtensionPage {
  addNewBot: boolean;
  upgrade: boolean;
  main: any[];
  qrcodeAvatarAccess: boolean;
}

interface BillingPage {
  free: {
    monthly: boolean;
    yearly: boolean;
  };
  basic: {
    monthly: boolean;
    yearly: boolean;
  };
  advance: {
    monthly: boolean;
    yearly: boolean;
  };
}

interface SettingsPage {
  openAi: OpenAi;
  widget: Widget2;
  extension: Extension3;
}

interface OpenAi {
  maxToken: boolean;
  configuration: boolean;
  upgrade: boolean;
}

interface Widget2 {
  customization: Customization;
  visibilityControl: VisibilityControl;
  setDomain: SetDomain;
  self: boolean;
  upgrade: boolean;
}

interface Customization {
  self: boolean;
  upgrade: boolean;
  voiceCommand: boolean;
  voiceResponse: boolean;
  defaultOpen: boolean;
  position: boolean;
  icon: boolean;
  theme: boolean;
  colors: boolean;
  avatar: boolean;
  name: boolean;
  poweredBy: boolean;
  userApiKeys: boolean;
  save_conversation: boolean;
  roundedVideo: boolean;
  alwaysShowButtons: boolean;
  notificationBadge: boolean;
  notificationMessage: boolean;
  notificationSound: boolean;
  isFullScreen: boolean;
  saveStats: boolean;
  sessionLimit: boolean;
  hideCloseButton?: boolean;
  displayAfter?: boolean;
  customCss: boolean;
}

interface VisibilityControl {
  self: boolean;
  upgrade: boolean;
  operatingHours: OperatingHours;
  widgetVisibilityControl: WidgetVisibilityControl;
}

interface OperatingHours {
  self: boolean;
  upgrade: boolean;
}

interface WidgetVisibilityControl {
  self: boolean;
  upgrade: boolean;
}

interface SetDomain {
  defaultDomain: DefaultDomain;
  localUse: LocalUse;
}

interface DefaultDomain {
  self: boolean;
  upgrade: boolean;
}

interface LocalUse {
  self: boolean;
  upgrade: boolean;
}

interface Extension3 {
  name: boolean;
  avatar: boolean;
  colors: boolean;
  theme: boolean;
  voiceCommand: boolean;
  poweredBy: boolean;
  upgrade: boolean;
}

interface HomePage {
  widget: Widget3;
  extension: Extension4;
  consumedSessions: ConsumedSessions;
  canCreate: CanCreate;
}

interface Widget3 {
  createNewBot: boolean;
  upgrade: boolean;
  isDefaultBot: boolean;
}

interface Extension4 {
  createNewBot: boolean;
  upgrade: boolean;
  isDefaultBot: boolean;
}

interface ConsumedSessions {
  scenarioBots: boolean;
  aIBots: boolean;
}

interface CanCreate {
  KITTY_01: Kitty01;
  CLONE_01: Clone01;
  KITTY_03: Kitty03;
  KITTY_04: Kitty04;
  MCBOT_01: Mcbot01;
  KITTY_02: Kitty02;
  VIDEO_SCENARIO: VideoScenario;
}

interface Kitty01 {
  self: boolean;
  upgrade: boolean;
}

interface Clone01 {
  self: boolean;
  upgrade: boolean;
}

interface Kitty03 {
  self: boolean;
  upgrade: boolean;
}

interface Kitty04 {
  self: boolean;
  upgrade: boolean;
}

interface Mcbot01 {
  self: boolean;
  upgrade: boolean;
}

interface Kitty02 {
  self: boolean;
  upgrade: boolean;
}

interface VideoScenario {
  self: boolean;
  upgrade: boolean;
}
